var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Broken/Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search_2",
    d: "M15.0036 14.2377L12.712 11.9972L12.6583 11.9155C12.5584 11.8161 12.4219 11.7601 12.2794 11.7601C12.1368 11.7601 12.0003 11.8161 11.9004 11.9155C9.95291 13.7022 6.95202 13.7993 4.88792 12.1425C2.82383 10.4856 2.33703 7.58891 3.75038 5.37344C5.16372 3.15798 8.03863 2.31123 10.4685 3.39475C12.8983 4.47828 14.1291 7.15586 13.3446 9.65172C13.2881 9.83203 13.3343 10.0281 13.4657 10.1661C13.5972 10.3041 13.794 10.363 13.9819 10.3207C14.1699 10.2784 14.3205 10.1413 14.377 9.96095C15.3148 6.99909 13.8984 3.8117 11.044 2.4607C8.18958 1.1097 4.75381 2.00054 2.95929 4.55694C1.16477 7.11333 1.55004 10.5681 3.86587 12.6863C6.18171 14.8046 9.73311 14.9506 12.2227 13.0299L14.2517 15.0137C14.4612 15.2177 14.8 15.2177 15.0096 15.0137C15.2189 14.8068 15.2189 14.4737 15.0096 14.2669L15.0036 14.2377Z",
    fill: "#667085"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.761b6e4a03b7290e856f8f7d288b4464.svg";
export { ForwardRef as ReactComponent };